import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';

import skeletonImage from 'assets/images/donutchartskeleton.svg?raw';

const DoughnutChartSkeletonRoot = styled('div')(() => ({
  position: 'relative',
  height: '100%',
  aspectRatio: '1/1',
  borderRadius: '50%',
  overflow: 'hidden',
  margin: '0 auto',
}));

const DoughnutChartCircleSkeleton = styled(Skeleton)(() => ({
  position: 'absolute',
  inset: 0,
  height: '100%',
  backgroundColor: 'white',
  backgroundImage: `url("data:image/svg+xml;base64, ${btoa(skeletonImage)}")`,
}));

export const DoughnutChartSkeleton = () => {
  return (
    <DoughnutChartSkeletonRoot>
      <DoughnutChartCircleSkeleton variant="rounded" animation="wave" />
    </DoughnutChartSkeletonRoot>
  );
};
